import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {DescriptionOutlined as DescriptionOutlinedIcon} from 'views/icons';
import {Translate} from 'views/module';

import TimelineCard from './TimelineCard';

import {formatEventDateTime} from '../dateTime';

const RecordCreation = (props) => {
  const {createdAt, eventTimezone} = props;

  const timeString = formatEventDateTime(createdAt, eventTimezone);
  return (
    <TimelineCard
      timeString={timeString}
      icon={DescriptionOutlinedIcon}
      iconColor="#b0b0b0"
      timeBg="#e0e0e0"
      title={<Translate expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Title' />}
      description={<Translate expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Description' />}
    >
      <Typography variant="body2" color="text.secondary">
        <Translate
          expression='schedule.eventDetail.EventTimelineSection.RecordCreation.Description'
        />
      </Typography>
    </TimelineCard>
  );
};

RecordCreation.propTypes = {
  createdAt: PropTypes.string.isRequired,
  eventTimezone: PropTypes.string.isRequired,
};

export default RecordCreation;
